import { SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';
import { AssetEssentials } from './asset-essentials';
import { SerializedSubscriptionDetails } from './serialized-subscription-details';

export interface SerializedSubscription<T = SubscriptionBookingStatus> extends AssetEssentials<string> {
  type: 'SUBSCRIPTION';
  subscriptionDetails: SerializedSubscriptionDetails<T>;
}
